var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"row",attrs:{"id":"terrain-profile"}},[_c('div',{staticClass:"col h-100"},[_c('elevation-plot',{attrs:{"geoJSON":_vm.course,"steps":_vm.width*0.4}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }